export const downloadTranslations = {
  DOWNLOAD_PAY_OFF: 'Download the Tranzer app.',
  DOWNLOAD_MAKE_US_POPULAR: 'Make us popular!'
};
